import { ReactComponent as PhoneIcon } from "core/assets/icons/phone.svg";
import { ReactComponent as CheckMarkIcon } from "core/assets/icons/checkmark-circle.svg";
import { ReactComponent as EmailIcon } from "core/assets/icons/email.svg";
import { ReactComponent as CellPhoneIcon } from "core/assets/icons/cellphone.svg";
import { ReactComponent as LocationIcon } from "core/assets/icons/location.svg";
import { ReactComponent as FacebookIcon } from "core/assets/icons/facebook.svg";
import { ReactComponent as ArrowHeadIcon } from "core/assets/icons/arrow-head.svg";
import { ReactComponent as FollowUsIcon } from "core/assets/icons/follow-us.svg";
import { ReactComponent as DrawerIcon } from "core/assets/icons/menu-outline.svg";
import { ReactComponent as CloseIcon } from "core/assets/icons/close.svg";
import { ReactComponent as MapMarkerIcon } from "core/assets/icons/map-marker.svg";

const Icons = {
  Phone,
  CheckMarkCircle,
  Email,
  CellPhone,
  Location,
  Facebook,
  ArrowHead,
  FollowUs,
  Drawer,
  Close,
  MapMarker,
};
function CheckMarkCircle(props?: React.SVGProps<SVGSVGElement>) {
  return <CheckMarkIcon {...props} />;
}

function Email(props?: React.SVGProps<SVGSVGElement>) {
  return <EmailIcon {...props} />;
}

function CellPhone(props?: React.SVGProps<SVGSVGElement>) {
  return <CellPhoneIcon {...props} />;
}

function Location(props?: React.SVGProps<SVGSVGElement>) {
  return <LocationIcon {...props} />;
}

function Facebook(props?: React.SVGProps<SVGSVGElement>) {
  return <FacebookIcon {...props} />;
}

function Phone(props?: React.SVGProps<SVGSVGElement>) {
  return <PhoneIcon {...props} />;
}

function ArrowHead(props?: React.SVGProps<SVGSVGElement>) {
  return <ArrowHeadIcon {...props} />;
}

function FollowUs(props?: React.SVGProps<SVGSVGElement>) {
  return <FollowUsIcon {...props} />;
}

function Drawer(props?: React.SVGProps<SVGSVGElement>) {
  return <DrawerIcon {...props} />;
}

function Close(props?: React.SVGProps<SVGSVGElement>) {
  return <CloseIcon {...props} />;
}

function MapMarker(props?: React.SVGProps<SVGSVGElement>) {
  return <MapMarkerIcon {...props} />;
}

export default Icons;

